import { render, staticRenderFns } from "./DocumentsTab.vue?vue&type=template&id=06fd345c&scoped=true"
import script from "./DocumentsTab.ts?vue&type=script&lang=ts&external"
export * from "./DocumentsTab.ts?vue&type=script&lang=ts&external"
import style0 from "./DocumentsTab.vue?vue&type=style&index=0&id=06fd345c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd345c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06fd345c')) {
      api.createRecord('06fd345c', component.options)
    } else {
      api.reload('06fd345c', component.options)
    }
    module.hot.accept("./DocumentsTab.vue?vue&type=template&id=06fd345c&scoped=true", function () {
      api.rerender('06fd345c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/details/DocumentsTab/DocumentsTab.vue"
export default component.exports